import { render, staticRenderFns } from "./DetailedBacklinkRenderer.vue?vue&type=template&id=18954cf2&scoped=true&"
import script from "./DetailedBacklinkRenderer.vue?vue&type=script&lang=js&"
export * from "./DetailedBacklinkRenderer.vue?vue&type=script&lang=js&"
import style0 from "./DetailedBacklinkRenderer.vue?vue&type=style&index=0&id=18954cf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18954cf2",
  null
  
)

/* custom blocks */
import block0 from "./DetailedBacklinkRenderer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports